import React from 'react';
import {
  Container,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircleOutline';

const steps = [
  {
    title: 'Discover',
    items: [
      'Understand business goals and success metrics',
      'Evaluate data and technology readiness',
      'Prioritise high-value use cases',
    ],
  },
  {
    title: 'Prototype',
    items: [
      'Run rapid experiments with real data',
      'Iterate with stakeholder feedback',
      'Demonstrate measurable impact',
    ],
  },
  {
    title: 'Scale',
    items: [
      'Build production-ready pipelines',
      'Transfer knowledge to your team',
      'Monitor and improve solutions',
    ],
  },
];

export default function OurProcess() {
  return (
    <Container sx={{ py: 8, color: 'common.white' }}>
      <Typography variant="h2" component="h2" align="center" color="secondary.main" gutterBottom>
        Our Process
      </Typography>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        {steps.map((step) => (
          <Grid item xs={12} md={4} key={step.title}>
            <Typography variant="h5" component="h3" gutterBottom color="common.white">
              {step.title}
            </Typography>
            <List>
              {step.items.map((item) => (
                <ListItem key={item} sx={{ alignItems: 'flex-start' }}>
                  <ListItemIcon>
                    <CheckIcon color="secondary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{ color: 'common.white' }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
